module.exports = __webpack_public_path__ + "media/images/gallery/constellations/sagitta/sge_gc-7666699647d2215d67de1c019372ba9a.gif";